export enum TempoRecebimento {
  D_30 = 1,
  D_14 = 2,
  D_5 = 3,
  D_2 = 4,
}

export const TEMPO_RECEBIMENTO_LABEL: Record<TempoRecebimento, string> = {
  [TempoRecebimento.D_30]: 'D+30',
  [TempoRecebimento.D_14]: 'D+14',
  [TempoRecebimento.D_5]: 'D+5',
  [TempoRecebimento.D_2]: 'D+2',
};

export const TEMPO_RECEBIMENTO_ORDER: TempoRecebimento[] = [
  TempoRecebimento.D_30,
  TempoRecebimento.D_14,
  TempoRecebimento.D_5,
  TempoRecebimento.D_2,
];

export interface ClienteTaxa {
  recebimento: TempoRecebimento;
  recebimentoDescricao: string;
  tempoRecebimento: number;
  taxaInternacional: number;
  reservaGlobal: number;
  taxaExtraInternacional: number;
  tempoReservaGlobal: number;
  taxaNacional: number;
  taxaPix: number;
  reservaNacional: number;
  taxaExtraNacional: number;
  tempoReservaNacional: number;
  taxaSaque: number;
}

export interface ClienteTaxasResponse {
  taxas: ClienteTaxa[];
}

export interface UpdateClienteTaxasPayload {
  taxas: ClienteTaxa[];
}
